// extracted by mini-css-extract-plugin
module.exports = {"list":"list-2Fs7u","root":"root-V3mdE"};